export default __webpack_public_path__ + "static/media/header_image.6ac7baed.png";